import axios from 'axios';
import { toast } from 'react-toastify';


const GLOBAL_ERROR_TOAST_ID = 'GLOBAL_API_ERROR';


const axiosInstance = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  },
});

// Request Interceptor — Inject token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const selectedUser = localStorage.getItem('marketplaceAcc');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ⚙️ Only set marketplace-id if not already manually set by caller
    if (!config.headers['marketplace-id'] && selectedUser) {
      try {
        const parsedUser = JSON.parse(selectedUser);
        if (parsedUser && parsedUser.id) {
          config.headers['marketplace-id'] = parsedUser.id;
        }
      } catch (e) {
        console.warn('Failed to parse selected user:', e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// axiosInstance.interceptors.response.use(
//   (response) => {
//     if (response.config?.silent) {
//       return response;
//     }
//     // Handle explicit success: false from backend
//     if (response?.data?.success === false) {
//       const message = response.data.message || 'Request failed.';
//       toast.error(message, {
//         position: 'bottom-right',
//         autoClose: 5000,
//       });
//     }
//     return response;
//   },
//   (error) => {
//     const status = error?.response?.status;
//     const data = error?.response?.data || {};
//     const token = localStorage.getItem('token');
//     let errorMessage = data.message || 'Something went wrong.';

//     if (error.config?.silent) {
//       return Promise.reject(error);
//     }

//     // Collect validation errors if available
//     if (data?.errors && typeof data.errors === 'object') {
//       const validationMessages = Object.values(data.errors).flat();
//       if (validationMessages.length > 0) {
//         errorMessage = validationMessages.join(', ');
//       }
//     }

//     if(status === 403 ){
//       return 
//     }

//     // Handle errors based on status and login state
//    else if (status === 401) {
//       // Unauthorized
//       if (token) {
//         // Token is present — session expired or invalid
//         toast.error('Session expired. Please log in again.', {
//           position: 'bottom-right',
//           autoClose: 5000,
//         });
//         localStorage.removeItem('token');
//         localStorage.removeItem('marketplaceAcc');
//         window.location.href = '/signin'; // optional redirect
//       } else {
//         toast.error(errorMessage || 'Invalid credentials.', {
//           position: 'bottom-right',
//           autoClose: 5000,
//         });
//       }
//     }  else if (status === 404) {
//       toast.error('Requested resource not found.', {
//         position: 'bottom-right',
//         autoClose: 5000,
//       });
//     } 
//     else if (status === 422) {
//       toast.error(data?.error || data?.errors?.[0]||errorMessage, {
//         position: 'bottom-right',
//         autoClose: 5000,
//       });
//     }
//     else if (status === 500) {
//       toast.error('Server error. Please try again later.', {
//         position: 'bottom-right',
//         autoClose: 5000,
//       });
//     } else {
//       // Other status or fallback
//       toast.error(errorMessage, {
//         position: 'bottom-right',
//         autoClose: 5000,
//       });
//     }

//     return Promise.reject(error);
//   }
// );



axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config?.silent) return response;

    if (response?.data?.success === false) {
      if (!toast.isActive(GLOBAL_ERROR_TOAST_ID)) {
        toast.error(response.data.message || 'Request failed.', {
          toastId: GLOBAL_ERROR_TOAST_ID,
        });
      }
    }
    return response;
  },
  (error) => {
    if (error.config?.silent) {
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const data = error?.response?.data || {};
    const token = localStorage.getItem('token');

    let errorMessage = data.message || 'Something went wrong.';

    if (data?.errors && typeof data.errors === 'object') {
      errorMessage = Object.values(data.errors).flat().join(', ');
    }

    // 403 → silent
    if (status === 403) {
      return Promise.reject(error);
    }

    // 401 → logout once
    // if (status === 401 && token) {
    //   if (!toast.isActive(GLOBAL_ERROR_TOAST_ID)) {
    //     toast.error('Session expired. Please log in again.', {
    //       toastId: GLOBAL_ERROR_TOAST_ID,
    //     });
    //   }
    //   localStorage.clear();
    //   window.location.href = '/signin';
    //   return Promise.reject(error);
    // }

    if (status === 401) {
  const message = data?.message || 'Unauthorized';

  if (token) {
    toast.error('Session expired. Please log in again.');
    localStorage.clear();
    window.location.href = '/signin';
  } else {
    toast.error(message,{
  position: 'bottom-right',
  autoClose: 5000,
}); // <-- login error shows correctly
  }

  return Promise.reject(error);
}


    const statusMessages = {
      404: 'Requested resource not found.',
      422: errorMessage,
      500: 'Server error. Please try again later.',
    };

    const finalMessage = statusMessages[status] || errorMessage;

    if (!toast.isActive(GLOBAL_ERROR_TOAST_ID)) {
      toast.error(finalMessage, {
        toastId: GLOBAL_ERROR_TOAST_ID,
        position: 'bottom-right',
        autoClose: 5000,
      });
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
